import StoryEkaterina from './StoryEkaterina';
export default StoryEkaterina;